import ITask from '../../../Utility/Task/ITask';
import CardSystem from '../CardSystem';
import { UIActions } from '../../../State/UI/UIActions';

export default class LevelCompleteMenuTask implements ITask<CardSystem> {
    public *execute(system: CardSystem): IterableIterator<number> {
        system.state.dispatch(
            UIActions.showPopup('levelCompleteMenu', {
                levelNumber: system.state.getState().levelState.levelNumber,
                goals: system.state.getState().levelState.winCriteria,
            })
        );
    }
}
